import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";

const LotteryBall = ({
  number,
  isHighlighted = false,
  color = "#fff",
  bgGradient = "linear-gradient(145deg, #ff416c, #ff4b2b)",
  size = isHighlighted ? 95 : 80,
}) => {
  if (!number) return null;

  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      <Box
        role="img"
        aria-label={`Número de lotería ${number}`}
        sx={{
          width: size,
          height: size,
          background: bgGradient,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold",
          color: color,
          fontSize: isHighlighted ? 28 : 24,
          textShadow: "0 2px 4px rgba(0,0,0,0.4)",
          border: "2px solid rgba(255,255,255,0.5)",
          backdropFilter: "blur(4px)",
          boxShadow: isHighlighted
            ? "0px 10px 20px rgba(0,0,0,0.3)"
            : "0px 6px 15px rgba(0,0,0,0.2)",
          transition: "transform 0.3s, box-shadow 0.3s",
          "&:hover": {
            transform: "scale(1.1)",
            boxShadow: "0px 15px 25px rgba(0,0,0,0.35)",
          },
        }}
      >
        <Typography variant="h6">{number}</Typography>
      </Box>
    </motion.div>
  );
};

export default LotteryBall;
